import React from 'react';
import { Box, Alert } from '@spothero/ui';
import useMobileBreakPoint from 'hooks/use-mobile-breakpoint';
import { TOOLTIPS, useTooltips } from 'pages/search/hooks/use-tooltips';
import { SEARCH_WIDGET_TOOLTIP_DARK_STYLE_OVERRIDE } from 'pages/search/utils/style/style-overrides';
const ToolTipSwitch = () => {
    const { isVisible: isTooltipVehicleVisible, text: tooltipVehicleText, handleClose: handleTooltipVehicleClose, } = useTooltips(TOOLTIPS.search_vehicle_popover);
    const { isVisible: isTooltipLoyaltyVisible, text: tooltipLoyaltyText, handleClose: handleTooltipLoyaltyClose, } = useTooltips(TOOLTIPS.loyalty_program_popover);
    if (isTooltipLoyaltyVisible)
        return (<Alert description={tooltipLoyaltyText} onDismissClick={handleTooltipLoyaltyClose} showDismiss status="neutral" background={'secondary.default'} showIcon={false}/>);
    if (isTooltipVehicleVisible)
        return (<Alert description={tooltipVehicleText} onDismissClick={handleTooltipVehicleClose} showDismiss status="neutral" showIcon={false}/>);
    return null;
};
export const MobileFilterCallouts = ({ showMissingVehicleTooltip = false, }) => {
    const { isVisible: isTooltipVehicleVisible } = useTooltips(TOOLTIPS.search_vehicle_popover);
    const { isVisible: isTooltipLoyaltyVisible } = useTooltips(TOOLTIPS.loyalty_program_popover);
    const isMobile = useMobileBreakPoint();
    const isVisible = isMobile &&
        ((isTooltipVehicleVisible && showMissingVehicleTooltip) ||
            isTooltipLoyaltyVisible ||
            false);
    return isVisible ? (<Box marginTop={2} marginBottom={4} 
    // MR 10/27 - I was asked not to put this style in fe-ui due to bigger design discussion
    sx={{
            '.chakra-alert': SEARCH_WIDGET_TOOLTIP_DARK_STYLE_OVERRIDE,
        }}>
            <ToolTipSwitch />
        </Box>) : null;
};
